import {useGuestGroup, useReservationSettings} from 'hooks';
import {useTranslation} from 'react-i18next';
import {validateGuestCount, isValidChildrenRegistration} from '../utils';
import {Participant} from '@guestapp/sdk';

function useValidateInstantChekinFlow() {
  const {guestGroup, leaderGuest} = useGuestGroup();
  const knownNumberOfGuests = guestGroup?.known_number_of_guests ?? 0;
  const addNumberOfGuests = guestGroup?.added_number_of_guests ?? 0;
  const remainingAllowedGuest = knownNumberOfGuests - addNumberOfGuests;

  const {t} = useTranslation();
  const {checkCanEditReservationDetails} = useReservationSettings();

  const validateParticipants = (participants: Participant[]) => {
    const errorMessage = t('please_select_an_adult');
    const isValid = isValidChildrenRegistration(
      participants,
      remainingAllowedGuest,
      Boolean(leaderGuest),
    );
    return {isValid, error: !isValid ? errorMessage : null};
  };

  const validateNumberOfGuests = (participants: Participant[]) => {
    const errorMessage = t('number_of_guests_exceeded', {
      count: knownNumberOfGuests,
    });
    const isValid = validateGuestCount({
      totalParticipants: participants.length,
      remainingAllowedGuest: remainingAllowedGuest,
      isNumberOfGuestsEditable: checkCanEditReservationDetails(),
    });
    return {isValid, error: !isValid ? errorMessage : null};
  };

  const validateFlow = (participants: Participant[]) => {
    const numberOfGuestsValidation = validateNumberOfGuests(participants);
    const participantsValidation = validateParticipants(participants);

    return {
      isValid: participantsValidation.isValid && numberOfGuestsValidation.isValid,
      error: participantsValidation.error || numberOfGuestsValidation.error,
    };
  };

  return {
    validateFlow,
  };
}

export {useValidateInstantChekinFlow};
